import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useContent } from '../../lib/ContentContext';
import { ContactForm } from './ContactForm';

export const ContactModal = ({ open, onClose }) => {
  const { content } = useContent();
  const homeContact = content?.home_contact || {};

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid="contact-modal-overlay"
      className="fixed inset-0 z-[100] flex items-start sm:items-center justify-center p-4 bg-black/60"
      onClick={onClose}
    >
      <div
        data-testid="contact-modal"
        className="relative w-full max-w-2xl bg-white rounded-2xl shadow-[0_24px_60px_rgba(17,24,39,0.3)] max-h-[92vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="contact-modal-close-button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 h-9 w-9 rounded-full bg-[#F6F7F9] hover:bg-[#eceef2] text-[#26247B] flex items-center justify-center transition-colors duration-200"
        >
          <X className="h-5 w-5" />
        </button>
        <div className="p-6 sm:p-10">
          <h2 className="text-[#2E8B57] font-extrabold text-2xl sm:text-3xl tracking-tight text-center">
            {homeContact.title || 'Reach Out to Our Team'}
          </h2>
          {homeContact.subtitle && (
            <p className="mt-3 text-black/80 text-sm leading-7 text-center max-w-xl mx-auto">{homeContact.subtitle}</p>
          )}
          <div className="mt-7">
            <ContactForm variant="home" productOptions={homeContact.product_options || []} />
          </div>
        </div>
      </div>
    </div>
  );
};
